module.exports = __webpack_public_path__ + "static/media/GH_branded_Side_Panel_Header.05534b27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GH_branded_Side_Panel_Header.svg
// module id = 239
// module chunks = 0